export const mapLatLngByRegion = {
  VIC: { lat: -37.840935, lng: 144.946457 },
  NSW: { lat: -33.852222, lng: 151.210556 },
  QLD: { lat: -31.953512, lng: 115.857048 },
  TAS: { lat: -27.470125, lng: 153.021072 },
  WA: { lat: -42.880554, lng: 147.324997 },
  NT: { lat: -12.462827, lng: 130.841782 },
  SA: { lat: -34.92123, lng: 138.599503 },
}

export const mapZoomByRegion = {
  VIC: 7,
  NSW: 11,
  QLD: 7,
  TAS: 7,
  WA: 8,
  NT: 10,
  SA: 11,
}
